import { modules } from "@core/utils/modules.js";

export default [
    {
        path: "attendance",
        name: "workshop-attendance",
        redirect: { name: "workshop-attendance-report" },
        component: () => import("@/views/workshop/views/workshop-attendance/WorkshopAttendanceMain.vue"),
        meta: {
            section: 23,
            module: modules.WORKSHOP

        },
        children: [
            {
                path: "report",
                name: "workshop-attendance-report",
                component: () =>
                    import(
              /* webpackChunkName: "TreasuryAttendanceReportTable" */ "@/views/commons/employee_attendance/AttendanceReportTable.vue"
                    ),
                meta: {
                    section: 23,
                    pageTitle: "Attendance",
                    module: modules.WORKSHOP,
                },
            },

        ],
    },
];